// File: cgp-snackbar.service.ts
// Author: Joseph M Diaz
// Date: 5/4/2017
// Desc: CGP Snackbar component.
// Other Contributors:

import { Injectable } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar, MatLegacySnackBarConfig as MatSnackBarConfig } from '@angular/material/legacy-snack-bar';

const defaults = {
    message: '',
    action: '',
    type: 'accept',
    duration: 3000,
    onAction: null
};

@Injectable()
export class CgpSnackbarService {
    constructor(private readonly snackbar: MatSnackBar) { }

    showSnackbar(opts) {
        const options = {
            ...defaults,
            ...opts
        };
        const config: MatSnackBarConfig = <MatSnackBarConfig>{
            duration: options.duration,
        }
        const snackbarRef = this.snackbar.open(options.message, options.action, config);

        snackbarRef.onAction().subscribe(() => {
            if (options.onAction) {
                options.onAction();
            }
        });

        return snackbarRef;
    }
}
